import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Access token and active account directly from localStorage to avoid circular dependency
  const token = localStorage.getItem('fluxtail-auth-token');
  const activeAccountId = localStorage.getItem('fluxtail-active-account');
  const router = inject(Router);

  // Always set Accept header to get JSON responses from Laravel
  const headers: Record<string, string> = {
    'Accept': 'application/json'
  };

  // Add Authorization header if token exists
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Add X-Active-Account header if account is selected (SECURITY: multi-tenancy isolation)
  // Skip for public auth endpoints (no account context)
  const skipAccountHeader = req.url.includes('/auth/login') ||
                            req.url.includes('/auth/register') ||
                            req.url.includes('/auth/social/') ||
                            req.url.includes('/auth/me') ||
                            req.url.includes('/accounts/memberships');

  if (activeAccountId && !skipAccountHeader) {
    headers['X-Active-Account'] = activeAccountId;
  }

  req = req.clone({ setHeaders: headers });

  return next(req).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 403 && err.error?.error?.includes('X-Active-Account')) {
          // Account access denied - redirect to account selection
          console.error('[Auth] Account access denied:', err.error);
          router.navigate(['/select-account']);
        }
      }
      throw err;
    })
  );
};
